import React from 'react';
import Layout from 'components/StaticPages/Layout';
import loc from 'sources/locale/loc';

export default function PrivacyPolicy() {
  return (
    <Layout title={loc('privacy-policy-title')}>
      {loc('privacy-policy-text')}
    </Layout>
  );
}



// WEBPACK FOOTER //
// ./src/components/StaticPages/PrivacyPolicy.jsx